angular.module('account').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('/account/views/changepassword.html',
    "<form name=\"changepasswordform\" ng-submit=\"$ctrl.submit(changepasswordform)\" novalidate>\r" +
    "\n" +
    "    <div ng-if=\"!$ctrl.loading && !httpError && $ctrl.isActiveDirectoryUser\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "        <div class=\"panel-subheading\">\r" +
    "\n" +
    "            {{::'Active Directory User Passwords Must Be Changed Through Windows' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"!$ctrl.loading && !httpError && !$ctrl.isActiveDirectoryUser\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "        <div class=\"panel-subheading\">\r" +
    "\n" +
    "            {{::'Please create a new password:' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12\">\r" +
    "\n" +
    "                <div class=\"form-group\"\r" +
    "\n" +
    "                            ng-class=\"{ 'has-error' : changepasswordform.oldPassword.$invalid && changepasswordform.$submitted}\">\r" +
    "\n" +
    "                    <label class=\"control-label\">{{::'Old Password' | translate}}</label>\r" +
    "\n" +
    "                    <div class=\"form-group\">\r" +
    "\n" +
    "                        <input class=\"form-control\"\r" +
    "\n" +
    "                                id=\"oldpassword\"\r" +
    "\n" +
    "                                name=\"oldPassword\"\r" +
    "\n" +
    "                                ng-model=\"$ctrl.model.OldPassword\"\r" +
    "\n" +
    "                                type=\"password\"\r" +
    "\n" +
    "                                placeholder=\"Old Password\"\r" +
    "\n" +
    "                                ng-disabled=\"showSecurityQuestions\"\r" +
    "\n" +
    "                                required\r" +
    "\n" +
    "                                >\r" +
    "\n" +
    "                        <span ng-show=\"changepasswordform.oldPassword.$invalid && changepasswordform.$submitted\"\r" +
    "\n" +
    "                                class=\"help-block ng-hide\">\r" +
    "\n" +
    "                        {{::'Not valid.' | translate}}\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12\">\r" +
    "\n" +
    "                <div class=\"form-group\"\r" +
    "\n" +
    "                     ng-class=\"{ 'has-error' : changepasswordform.newPassword.$invalid && changepasswordform.$submitted}\">\r" +
    "\n" +
    "                    <label class=\"control-label\">{{::'New Password' | translate}}</label>\r" +
    "\n" +
    "                    <input class=\"form-control\"\r" +
    "\n" +
    "                           id=\"newPassword\"\r" +
    "\n" +
    "                           name=\"newPassword\"\r" +
    "\n" +
    "                           ng-model=\"$ctrl.model.NewPassword\"\r" +
    "\n" +
    "                           type=\"password\"\r" +
    "\n" +
    "                           placeholder=\"New Password\"\r" +
    "\n" +
    "                           ng-minlength=\"5\"\r" +
    "\n" +
    "                           required\r" +
    "\n" +
    "                            >\r" +
    "\n" +
    "                    <span ng-show=\"changepasswordform.newPassword.$invalid && changepasswordform.$submitted\"\r" +
    "\n" +
    "                          class=\"help-block ng-hide\">\r" +
    "\n" +
    "                            {{::'Password must be at least 5 characters.' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12\">\r" +
    "\n" +
    "                <div class=\"form-group\"\r" +
    "\n" +
    "                     ng-class=\"{ 'has-error' : changepasswordform.confirmNewPassword.$invalid && changepasswordform.$submitted}\">\r" +
    "\n" +
    "                    <label class=\"control-label\">{{::'Retype New Password' | translate}}</label>\r" +
    "\n" +
    "                    <input class=\"form-control\"\r" +
    "\n" +
    "                           id=\"confirmNewPassword\"\r" +
    "\n" +
    "                           name=\"confirmNewPassword\"\r" +
    "\n" +
    "                           ng-model=\"$ctrl.confirmNewPassword\"\r" +
    "\n" +
    "                           type=\"password\"\r" +
    "\n" +
    "                           placeholder=\"Retype Password\"\r" +
    "\n" +
    "                           ng-pattern=\"$ctrl.model.NewPassword\"\r" +
    "\n" +
    "                           required\r" +
    "\n" +
    "                            >\r" +
    "\n" +
    "                    <span ng-show=\"changepasswordform.confirmNewPassword.$invalid && changepasswordform.$submitted\"\r" +
    "\n" +
    "                          class=\"help-block ng-hide\">\r" +
    "\n" +
    "                            {{::'Passwords do not match.' | translate}}\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"panel-footer panel-flush\">\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-6\">\r" +
    "\n" +
    "                    <button type=\"button\" class=\"btn btn-default2 btn-lg\" ng-click=\"$ctrl.back()\">{{'Back' | translate}}</button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-6\">\r" +
    "\n" +
    "                    <button type=\"submit\" class=\"btn btn-primary btn-lg pull-right\"\r" +
    "\n" +
    "                            ng-disabled=\"$ctrl.loading\">\r" +
    "\n" +
    "                        <ap-spinner ng-show=\"$ctrl.loading\"></ap-spinner>\r" +
    "\n" +
    "                        {{'Submit' | translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"$ctrl.loading || httpError\">\r" +
    "\n" +
    "        <div class=\"text-center\" ng-if=\"$ctrl.loading\">\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"alert alert-danger\" ng-if=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{\"An error has occurred and the page could not be loaded.\" | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"alert alert-danger\" ng-if=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "            {{\"You do not have access to this info.\"| translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</form>"
  );

}]);
